import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function Container({ isResponsive, loading, className, children }) {
  const tableContainerClasses = classNames(
    "table-container",
    {
      "table-responsive": isResponsive,
      "table-loading": loading,
      "table-placeholder": loading
    },
    className
  );

  return <div className={tableContainerClasses}>{children}</div>;
}

Container.defaultProps = {
  isResponsive: true,
  loading: false,
  className: null,
  children: null
};

Container.propTypes = {
  // Скрол x?
  isResponsive: PropTypes.bool,
  // Загрузка?
  loading: PropTypes.bool,
  // Класс контейнера
  className: PropTypes.string,
  // Ребёнок
  children: PropTypes.node
};

export default Container;
